// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"emojione-view_shadow__3KdbC","button":"emojione-view_button__1VWWK","emoji":"emojione-view_emoji__1LB3n"};